export const DEVICE_ID = 'BXL_META_device_id'

export const BASE_HOST = {
  'grotto': 'https://santa-grotto.santasmartnetwork.com',
  'laas': 'https://santa-laas.santasmartnetwork.com',
  'ewe': 'https://santa-ewe.santasmartnetwork.com',
}